<template>
  <div v-if="notFound" :class="componentClassName">
    <a-page-heading>申し込み管理 </a-page-heading>

    <m-section>
      <m-action-card id="settingsRequestTitle" :title="`企業情報 （${companyList.length}）`">
        <div class="t-setting-company-request__filters">
          <div class="t-setting-company-request__search">
            <a-select-field
              id="-selectServiceList"
              v-model="selectedService"
              class="t-setting-company-request__selectservice"
              :options="serviceList"
            />
            <span class="t-setting-company-request__search-separator" />
            <a-select-field
              id="searchType"
              v-model="searchType"
              class="t-setting-company-request__selecttype"
              :options="searchTypeOptions"
              @change="handleChange"
            />
            <span class="t-setting-company-request__search-separator" />
            <a-text-field
              id="searchFilter"
              v-model="searchWord"
              type="search"
              placeholder="検索"
              maxlength="50"
              @keypress.enter.stop="handleSearchInput"
            />
          </div>
          <a-button
            id="viewButton"
            class="t-setting-company-request__nowrap"
            :inline="true"
            variant="fill"
            color="primary"
            size="medium"
            label="表示"
            @click="handleSearchInput"
          />
        </div>
        <m-data-table ref="dataTable" empty-text="登録がありません" :fit="true" :data="filterList">
          <a-data-table-column prop="documentID" label="契約ID" align="left" :filterable="true" :min-width="120">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_documentID"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('documentID', 'asc')"
                :handle-sort-descending="() => handleSort('documentID', 'desc')"
              />
            </template>
          </a-data-table-column>

          <a-data-table-column prop="companyName" label="契約企業名" align="left" :filterable="true" :min-width="100">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_companyName"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('companyName', 'asc')"
                :handle-sort-descending="() => handleSort('companyName', 'desc')"
              />
            </template>
          </a-data-table-column>

          <a-data-table-column prop="adminName" label="マスタ管理者名" align="left" :filterable="true" :min-width="100">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_adminName"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('adminName', 'asc')"
                :handle-sort-descending="() => handleSort('adminName', 'desc')"
              />
            </template>
          </a-data-table-column>

          <a-data-table-column
            class="t-setting-company-request__wrap"
            prop="adminEmail"
            :filterable="true"
            :min-width="100"
            label="メールアドレス"
            align="left"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_adminEmail"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('adminEmail', 'asc')"
                :handle-sort-descending="() => handleSort('adminEmail', 'desc')"
              />
            </template>
          </a-data-table-column>

          <a-data-table-column
            class="t-setting-company-request__wrap"
            prop="requestDate"
            :filterable="true"
            :min-width="100"
            label="申し込み日"
            align="left"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_requestDate"
                variant="sort-time"
                :handle-sort-ascending="() => handleSort('requestDate', 'asc')"
                :handle-sort-descending="() => handleSort('requestDate', 'desc')"
              />
            </template>
          </a-data-table-column>

          <a-data-table-column type="action" :width="160" align="center" class="a-data-table-column--action">
            <template #default="scope">
              <a-button
                :id="'ApplyInfoEdit' + scope.index"
                variant="round"
                size="small"
                label="編集"
                color="grey"
                icon="edit"
                icon-color="black"
                :inline="true"
                @click="handleCompanyEdit(scope.row)"
              />
            </template>
          </a-data-table-column>
        </m-data-table>
      </m-action-card>
    </m-section>
  </div>

  <!-- Confirm, Error Modal -->
  <teleport to="body">
    <o-modal
      id="settingCompanyRequest_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';
import * as Handlebars from 'handlebars';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import MFilterDialog from '@/components/molecules/filter-dialog';
import { POINT } from '@/libs/constants';

export default {
  name: 't-setting-company-request',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    AText,
    MDataTable,
    ADataTableColumn,
    OModal,
    MFilterDialog,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedCompanyID: '',
      companyList: [],
      filterList: [],
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      notFound: false,
      selectedService: 'ccc',
      serviceList: [
        {
          label: 'COTOHA Voice DX Basic・COTOHA Call Center共用',
          value: 'ccc',
        },
        {
          label: 'COTOHA Voice DX Basicのみ',
          value: 'voicedx',
        },
      ],
      searchTypeOptions: [
        {
          value: 'documentID',
          label: '契約ID',
        },
        {
          value: 'companyName',
          label: '契約企業名',
        },
        {
          value: 'adminName',
          label: 'マスタ管理者',
        },
        {
          value: 'adminEmail',
          label: 'メールアドレス',
        },
        {
          value: 'requestDate',
          label: '申し込み日',
        },
      ],
      searchType: 'documentID',
      searchWord: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-company-request');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async created() {
    if (this.companyID === POINT) {
      await this.handlerFetchCompanyData();
    }
  },
  mounted() {
    if (this.companyID !== POINT) {
      this.$router.push({ path: '/permission-denied' });
    }
  },
  methods: {
    handlerFetchCompanyData: async function () {
      this.companyList = [];
      this.notFound = true;
      this.selectedCompanyID = '';

      await this.postRequest('/entry/getRequestList')
        .then(e => {
          if (e.status === 'success') {
            for (let i = 0; i < e.data.length; i++) {
              // 姓名の空白置換
              if (e.data[i].adminName.indexOf('_') !== -1) {
                e.data[i].adminName = e.data[i].adminName.replace('_', ' ');
              }
              // historyCollectionのPathから申し込み日を算出
              e.data[i].requestDate = '';
              const dateStr = e.data[i].documentPath;
              if (typeof dateStr !== 'undefined') {
                const dateFormatStr = dateStr.slice(0, 4) + '/' + dateStr.slice(4, 6) + '/' + dateStr.slice(6, 8);
                if (!isNaN(Date.parse(dateFormatStr))) {
                  e.data[i].requestDate = dateFormatStr;
                }
              }
            }
            this.companyList = e.data;
            this.setDisplayCompanyList();
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('登録ユーザー取得'));
        });
    },
    setDisplayCompanyList(searchType, searchWord) {
      const tmplist = this.companyList.filter(companyInfo => {
        return companyInfo['voicedxOnlyFlag'] === (this.selectedService === 'ccc' ? false : true);
      });
      if (typeof searchType === 'undefined' || typeof searchWord === 'undefined' || searchWord === '') {
        this.filterList = tmplist;
        return;
      }
      this.filterList = tmplist.filter(companyInfo => {
        if (typeof companyInfo[searchType] === 'undefined') {
          return false;
        }
        return companyInfo[searchType].indexOf(searchWord) !== -1;
      });
    },
    handleCompanyEdit(row) {
      this.$router.push({ path: '/companyrequest/edit', query: { documentID: row.documentID } });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message, selectedCompanyID) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.companyList = this.companyList.filter(function (v) {
        return v.companyID !== selectedCompanyID;
      });
    },
    // 検索タイプを変更した時の処理
    handleChange() {
      this.searchWord = '';
    },
    // 検索実行時の処理
    handleSearchInput() {
      this.setDisplayCompanyList(this.searchType, this.searchWord);
    },
    getFilterColumnIndex(prop) {
      let columnIndex = -1;
      this.$refs.dataTable.columns.forEach((column, index) => {
        if (column.prop === prop) {
          columnIndex = index;
        }
      });
      return columnIndex;
    },
    handleFilterCancel(prop) {
      const columnIndex = this.getFilterColumnIndex(prop);
      if (columnIndex !== -1) {
        this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
      }
    },
    handleSort(prop, dir) {
      //昇順
      if (dir === 'asc') {
        this.filterList.sort(function (a, b) {
          if (a[prop] < b[prop]) return -1;
          if (a[prop] > b[prop]) return 1;
          return 0;
        });
      }
      //降順
      if (dir === 'desc') {
        this.filterList.sort(function (a, b) {
          if (a[prop] > b[prop]) return -1;
          if (a[prop] < b[prop]) return 1;
          return 0;
        });
      }
      this.handleFilterCancel(prop);
    },
  },
};
</script>
